import { Center, Modal, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import { Spinner } from '../atoms/spinner';

interface SpinnerModalProps {
  show: boolean;
  id?: string;
}

export const SpinnerModal = (props: SpinnerModalProps) => {
  const { show, id = 'enroly' } = props;

  const { onClose } = useDisclosure();

  return (
    <>
      {show && (
        <Modal
          id={`${id}-loading`}
          data-selector="spinner-modal"
          onClose={onClose}
          isOpen={!!show}
          aria-busy={!!show}
          useInert={false}
        >
          <ModalOverlay bgColor="whiteAlpha.300" zIndex="overlay" />

          <Center width="100vw" height="100vh" position="fixed" left="0" top="0" zIndex="overlay">
            <Spinner />
          </Center>
        </Modal>
      )}
    </>
  );
};
